//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from "better-scroll";
import tableGrid from "../../components/tableGrid";
import cellGrid from "../../components/cellGrid";
import layer from "./layer.vue";
import secondary from "./secondary";
import { FactoryUtils } from "@/utils/FactoryUtils";
import { hospitalPolicy } from "../../model/api/detailService.js";
import hostList from "@/utils/hostList";
export default {
	name: "mipLightbox",
	data() {
		return {
			resData: {},
			insureTitle: "",
			planBScroll: null,
			showFlag: false,
			planDetails: {},
			cell: [],
			morecell: [],
			thStyle: ["width:4rem", "width:9rem;font-size:13px", "width:5rem;"],
			tabledata: {},
			infoList: [],
			serveInfo: {},
			allServe: "",
			secondaryPage: false, // 二级页面
			secondaryInfo: {},
			illness: {}, //百万医疗
			medicalBeauty: {}, //医疗美容项目
		};
	},
	components: {
		cellGrid,
		tableGrid,
		layer,
		secondary,
	},
	props: {
		serverTips: {
			// 0 保障详情  1 重疾绿通  2 100种重大疾病    一级页面展示类型
			type: [Number, String],
			default() {
				return 0;
			},
		},
	},
	created() {
		FactoryUtils.planDetails().then((res) => {
			this.resData = res;
			this.check(this.resData);
		});
	},
	watch: {
		serverTips(newValue, oldValue) {
			this.check(this.resData);
		},
	},
	methods: {
		skip(e) {
			this.STATISTICS("click", "sybao_ins_greenchannel_hospitals_click");
			console.log("34567890-=", e);
			this[e]();
		},
		famous() {
			//知名
			this.secondaryInfo = {
				title: "服务医院清单",
				illnessList: data,
			};
		},
		hostFamous() {
			this.secondaryPage = true;
			console.log(hostList);
			this.secondaryInfo = {
				title: "服务医院清单",
				illnessList: hostList.hostList.hostFamous,
			};
		},
		hostPublic() {
			//公立
			this.secondaryPage = true;
			console.log(hostList);
			this.secondaryInfo = {
				title: "公立医院清单",
				illnessList: hostList.hostList.hostPublic,
			};
		},
		check(res) {
			//表格切换
			this.insureTitle = res.insureTitle;
			this.illness = res.illness;
			this.medicalBeauty = res.medical_beauty;
			if (this.serverTips == "1") {
				if (res.tableList) {
					this.insureTitle = res.tableList.table_title;
					this.tabledata = res.tableList.table_content;
				}
				if (res.tableList && res.tableList.serveInfo) {
					this.serveInfo = res.tableList.serveInfo;
				}
				if (res.allServe) {
					this.allServe = res.allServe.allServeList;
					this.insureTitle = res.allServe.allServe_title;
				}
				this.secondaryPage = false;
			} else if (this.serverTips == "0") {
				this.planDetails = res;
				if (res.tableList && res.tableList.serveInfo) {
					this.serveInfo = res.tableList.serveInfo;
				}
				this.infoList = res.infoList;
				this.cell = res.cellList;
				this.morecell = res.moreCellList;
				if (res.tableList && res.tableList.table_content) {
					this.tabledata = res.tableList.table_content;
				}
				this.secondaryPage = false;
			} else if (this.serverTips == "2") {
				//100种重大疾病
				this.clickInfo("100种重大疾病");
			}
		},
		clickInfo(e) {
			this.secondaryPage = true;
			if (e == "《医疗美容项目表》") {
				this.$emit("beautyprojects");
				this.secondaryInfo = this.medicalBeauty;
			}
			if (e == "100种重大疾病") {
				this.$emit("disease");

				this.secondaryInfo = this.illness;
			}
		},
		serveClick(e) {
			this.$emit("hospitals");
			hospitalPolicy().then((data) => {
				console.log("666", data);
				this.secondaryPage = true;
				this.secondaryInfo = {
					title: "服务医院清单",
					illnessList: data,
				};
			});
		},
		handler(ev) {
			ev.preventDefault();
		},
		showToast(e) {
			this.showFlag = true;
			this.check(this.resData);
			//console.log('111',this.planBScroll)
			this.$nextTick(() => {
				if (!this.planBScroll) {
					this.planBScroll = new BScroll(this.$refs.planBox, {
						click: true,
						scrollY: true,
					});
				} else {
					this.planBScroll.refresh();
				}
			});
			// document.body.addEventListener('touchmove', this.handler, { passive: false });
		},
		secondaryClose() {
			this.secondaryPage = false;
		},
		close() {
			this.$refs.layerRef.removeTouch();
			this.showFlag = false;
			this.planBScroll = null;
			this.secondaryPage = false;
		},
	},
};
